import React, { useState, useEffect } from "react";
import "./style.css";

const CandidateManager = () => {
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingEnrollID, setEditingEnrollID] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [searchTerm, setSearchTerm] = useState("");



  // Fetch all candidates
  const fetchCandidates = async () => {
    setLoading(true);
    try {
      const res = await fetch("https://elearn-api.onrender.com/api/getCandidates");
      const data = await res.json();
      setCandidates(data);
    } catch (err) {
      console.error("Error fetching candidates:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCandidates();
  }, []);

  // Handle delete
  const handleDelete = async (EnrollID) => {
    if (!window.confirm("Are you sure you want to delete this candidate?")) return;
    try {
      await fetch(`https://elearn-api.onrender.com/api/deleteCandidate/${EnrollID}`, { method: "DELETE" });
      setCandidates(candidates.filter(c => c.EnrollID !== EnrollID));
    } catch (err) {
      console.error("Error deleting candidate:", err);
    }
  };

  // Start editing
  const handleEdit = (candidate) => {
    setEditingEnrollID(candidate.EnrollID);
    setEditForm({ ...candidate });
  };

  // Handle form changes
  const handleChange = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  // Submit edit
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await fetch(`https://elearn-api.onrender.com/api/updateCandidate/${editingEnrollID}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(editForm),
      });
      setEditingEnrollID(null);
      fetchCandidates();
    } catch (err) {
      console.error("Error updating candidate:", err);
    }
  };
const filteredCandidates = candidates.filter((c) =>
  c.Name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  c.NricId?.toLowerCase().includes(searchTerm.toLowerCase())
);
  return (
    <div className="candidate-manager-container">
      <h1 className="cm-title">Candidate Management</h1>
<div className="cm-search">
  <input
    type="text"
    placeholder="🔍 Search by Name or NRIC ID..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />
</div>
      {loading ? (
        <p className="cm-loading">Loading candidates...</p>
      ) : (
        <table className="cm-table">
          <thead>
            <tr>
              <th>EnrollID</th>
              <th>NricId</th>
              <th>Name</th>
              <th>DOB</th>
              <th>CourseID</th>
              <th>BatchNo</th>
              <th>Mobile</th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredCandidates.map((c) => (
              <tr key={c.EnrollID}>
                <td>{c.EnrollID}</td>
                <td>{c.NricId}</td>
                <td>
                  {editingEnrollID === c.EnrollID ? (
                    <input
                      className="cm-input"
                      type="text"
                      name="Name"
                      value={editForm.Name}
                      onChange={handleChange}
                    />
                  ) : (
                    c.Name
                  )}
                </td>
                <td>
                  {editingEnrollID === c.EnrollID ? (
                    <input
                      className="cm-input"
                      type="date"
                      name="DOB"
                      value={editForm.DOB?.split("T")[0] || ""}
                      onChange={handleChange}
                    />
                  ) : (
                    c.DOB?.split("T")[0]
                  )}
                </td>
                <td>
                  {editingEnrollID === c.EnrollID ? (
                    <input
                      className="cm-input"
                      type="text"
                      name="CourseID"
                      value={editForm.CourseID}
                      onChange={handleChange}
                    />
                  ) : (
                    c.CourseID
                  )}
                </td>
                <td>
                  {editingEnrollID === c.EnrollID ? (
                    <input
                      className="cm-input"
                      type="text"
                      name="BatchNo"
                      value={editForm.BatchNo}
                      onChange={handleChange}
                    />
                  ) : (
                    c.BatchNo
                  )}
                </td>
                <td>
                  {editingEnrollID === c.EnrollID ? (
                    <input
                      className="cm-input"
                      type="text"
                      name="Mobile"
                      value={editForm.Mobile}
                      onChange={handleChange}
                    />
                  ) : (
                    c.Mobile
                  )}
                </td>
                <td>
                  {editingEnrollID === c.EnrollID ? (
                    <input
                      className="cm-input"
                      type="email"
                      name="Email"
                      value={editForm.Email}
                      onChange={handleChange}
                    />
                  ) : (
                    c.Email
                  )}
                </td>
                <td>
                  {editingEnrollID === c.EnrollID ? (
                    <>
                      <button className="cm-btn cm-save-btn" onClick={handleUpdate}>
                        Save
                      </button>
                      <button className="cm-btn cm-cancel-btn" onClick={() => setEditingEnrollID(null)}>
                        Cancel
                      </button>
                    </>
                  ) : (
                    <>
                      <button className="cm-btn cm-edit-btn" onClick={() => handleEdit(c)}>
                        Edit
                      </button>
                      <button className="cm-btn cm-delete-btn" onClick={() => handleDelete(c.EnrollID)}>
                        Delete
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default CandidateManager;
